<script>
	import { page } from "$app/stores";
	import { PUBLIC_APP_NAME } from "$env/static/public";
	import CTABottomOverlay from "$lib/components/CTABottomOverlay.svelte";
	import LazyImage from "$lib/components/LazyImage.svelte";
	import OgParams from "$lib/components/OgParams.svelte";
	import PlanSpecs from "$lib/components/PlanSpecs.svelte";
	import ViewerInitButton from "$lib/components/ViewerInitButton.svelte";
	import { utilityButtons } from "$lib/store";
	import { doShare, markdownFormat, prepareOptionsForArSession } from "$lib/utils";
	import { head } from "lodash-es";
	import { getContext, onMount } from "svelte";

	/** @type {import('./$types').PageData} */
	export let data;

	/** @type {DeviceInfo} */
	const deviceInfo = getContext("deviceInfo");

	let imageUrl = head(data.plan.options)?.image?.url;

	/** @type {OptionForARSession[]} */
	let options = [];
	$: options = prepareOptionsForArSession(data.plan?.options);

	onMount(() => {
		// TODO: Shortlist buttons
		$utilityButtons = [
			// {
			// 	class: "i-ph:heart",
			// 	fn: () => console.log("Shortlist me!"),
			// },
			{
				class: "i-ph:share-network",
				fn: (e) =>
					doShare(
						`${$page.url.origin}${$page.url.pathname}/link`,
						`${data.plan.name} - ${PUBLIC_APP_NAME}`,
						deviceInfo,
						e,
					),
			},
		];

		return () => {
			$utilityButtons = [];
		};
	});
</script>

<OgParams title={data.plan.name} description={data.plan.description} {imageUrl} />

<div class="flex flex-col gap-4 max-w-180 mx-auto">
	{#if imageUrl}
		<div class="rounded-lg shadow-md overflow-clip">
			<LazyImage url={imageUrl} height="240" imageWidth="720" />
		</div>
	{/if}
	<div class="flex flex-wrap justify-between gap-4">
		<h1>{data.plan.name}</h1>
		<div class="flex flex-grow items-center max-w-100">
			<PlanSpecs specs={data.plan.specs} />
		</div>
	</div>
	{#if options.length > 1}
		<div class="italic">{options.length} elevations available</div>
	{/if}
	<!-- AR/3D button -->
	<ViewerInitButton {options} />
	{@html markdownFormat(data.plan.description)}
</div>

<!-- Spacer for CTA overlay -->
<div class="h-15" />

<CTABottomOverlay planId={data.plan.key} />
